import { formatRangeLabel } from "@/components/v2/DatePicker/utils";
import { UNIT_LABELS } from "@/pages/reporting_v2/constants";
import { ReportingPageContext } from "@/pages/reporting_v2/context";
import { REPORTING_VIEW_TYPES } from "@/pages/reporting_v2/types";
import { useTrans } from "@/translations";

import { useContext, useMemo } from "react";

import { ReportingTableContext } from "../context";

export const ReportingFooter: React.FC = () => {
  const { t } = useTrans();
  const { datePreset, dateRange, viewType } = useContext(ReportingPageContext);
  const { nrTotal, nrSelected, showZones, unit } = useContext(
    ReportingTableContext,
  );

  const displayPeriod = useMemo(
    () => t(formatRangeLabel(datePreset, dateRange)),
    [datePreset, dateRange, t],
  );

  const totalLabel = useMemo(() => {
    if (viewType === REPORTING_VIEW_TYPES.PORTFOLIO) {
      return t("reportingPage:footerTotalBuildings");
    } else if (viewType === REPORTING_VIEW_TYPES.BUILDING) {
      if (showZones) {
        return t("reportingPage:footerTotalZones");
      } else {
        return t("reportingPage:footerTotalTenants");
      }
    }
  }, [viewType, t, showZones]);

  const selectedLabel = useMemo(() => {
    if (!nrSelected) {
      return "";
    } else
      return ` · ${t("reportingPage:footerSelected", { nrRows: nrSelected })}`;
  }, [nrSelected, t]);

  return (
    <div className="border-t-grey2 flex flex-wrap items-center justify-between gap-[12px] border-t px-[22px] py-[12px]">
      <span className="text-grey6 text-[12.5px]">
        {nrTotal} {totalLabel}
        {selectedLabel}
      </span>
      <span className="text-[12px] text-[#9a958f]">
        {t("reportingPage:footerUnitLabel", {
          unit: UNIT_LABELS[unit],
          interpolation: { escapeValue: false },
        })}{" "}
        · {displayPeriod}
      </span>
    </div>
  );
};
